// import { Cancel } from 'iconoir-react'
import React from 'react'

const NotificationCard = ({heading, time, body, isViewed}) => {
  return (
    <div className='h-28 w-full border-b mb-1'>
      <div className='flex justify-between items-center'>
        <p className='wayrideColor mb-2 text-sm font-semibold'>Greetings from Hello world </p>
        <small className='border rounded-md bg-yellow-500 text-white text-xs px-2'>new</small>
      </div>
      <p className='text-sm line-clamp-3 mb-1 text-gray-500 overflow-ellipsis overflow-hidden'>It is a long established fact that a reader will be  distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed</p>
      <p className='text-xs wayrideColor text-right'>48 minutes ago</p>
    </div>
  )
}

export default NotificationCard